import React from 'react'
import styled from 'styled-components'
import Error from './Utils/Error'
import Cookies from 'universal-cookie'
import Spinner from './Utils/Spinner'
import { withAuth } from './AuthContext'
import { Link, withRouter } from 'react-router-dom'
import { isValidEmail } from '../utils/utils'
import { withSearch } from './SearchContext'
import { gaEvents } from '../analytics/events'
import {
  Container,
  ContainerFlexColumn,
  Input,
  Title,
  CustomSubtitle,
  ActionButtons,
  BackOutline,
  CustomSelect,
  CheckboxWrapper,
  CustomCheckbox,
} from './Utils/CustomClasses'
import { shouldTranslateTo } from '../utils/utils'

const cookies = new Cookies()

const CustomContainer = styled(Container)`
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 30px 10px;
  }
`

const Box = styled.div`
  background-color: #fff;
  padding: 40px;

  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`

const Form = styled.form`
  text-align: left;
  width: 40vw;
  min-width: 400px;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const SubmitButton = styled(ActionButtons)`
  margin-top: 30px;
  width: -webkit-fill-available;
  justify-content: center;
`

const LineBreak = styled.hr`
  width: 40vw;
  min-width: 400px;
  border-top: 1px solid rgba(0, 0, 0, 0.24);
  margin: 45px 0;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
    margin: 30px 0;
  }
`

const CustomCheckboxWrapper = styled(CheckboxWrapper)`
  margin-top: -20px;
  margin-bottom: 20px;
`

const CustomCheckboxForm = styled(CustomCheckbox)`
  border: 2px solid rgba(17, 17, 19, 0.39);
  border-radius: 50%;
  margin-left: 6px;
  height: 30px;
  width: 30px;
`

const GiftYourRecipientForm = (props) => {
  const [title, setTitle] = React.useState('')
  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')
  const [over50, setOver50] = React.useState('')
  const [country, setCountry] = React.useState('')
  const [citySelect, setCitySelect] = React.useState('')
  const [cityInput, setCityInput] = React.useState('')
  const [isNewCity, setIsNewCity] = React.useState(false)
  const [email, setEmail] = React.useState('')
  const [titleError, setTitleError] = React.useState(false)
  const [firstNameError, setFirstNameError] = React.useState(false)
  const [lastNameError, setLastNameError] = React.useState(false)
  const [over50Error, setOver50Error] = React.useState(false)
  const [countryError, setCountryError] = React.useState(false)
  const [cityError, setCityError] = React.useState(false)
  const [emailError, setEmailError] = React.useState(false)
  const [error, setError] = React.useState({})
  const [loading, setLoading] = React.useState(false)
  const [pageText, setPageText] = React.useState([])
  const [cities, setCities] = React.useState([])

  React.useEffect(() => {
    const savedRecipient = JSON.parse(localStorage.getItem('recipient'))
    if (savedRecipient) {
      setTitle(savedRecipient.title)
      setFirstName(savedRecipient.firstName)
      setLastName(savedRecipient.secondName)
      setOver50(savedRecipient.overfifty)
      setCountry(savedRecipient.country)
      setCitySelect(savedRecipient.locationId)
      setCityInput(savedRecipient.city)
      setIsNewCity(savedRecipient.is_new_city)
      setEmail(savedRecipient.email)
      setCities(savedRecipient.cities)
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('GYGU-recipient-form', language, setPageText)
  }, [])

  const { history, search } = props

  const countrySelected = search.countriesNice.find((c) => c.value === country)

  const updateTitle = (e) => {
    setTitleError(false)
    setError(null)
    setTitle(e['value'])
  }

  const updateFirstName = (e) => {
    setFirstNameError(false)
    setError(null)
    setFirstName(e)
  }

  const updateLastName = (e) => {
    setLastNameError(false)
    setError(null)
    setLastName(e)
  }

  const updateOver50 = (e) => {
    setOver50Error(false)
    setError(null)
    setOver50(e.value)
  }

  const updateCountry = async ({ value }) => {
    setCitySelect('')
    setCityInput('')
    setCountryError(false)
    setError(null)
    setCountry(value)
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let citiesResult = response.data.map((city) => {
        return { value: city.id, label: city.city }
      })
      setCities(citiesResult)
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  const updateCity = (e) => {
    setCityError(false)
    setError(null)
    if (isNewCity) {
      setCityInput(e)
    } else {
      setCityInput(e.label)
      setCitySelect(e.value)
    }
  }

  const updateIsNewCity = (e) => {
    setError(null)
    setCityInput('')
    setCitySelect(0)
    if (isNewCity) {
      setIsNewCity(false)
    } else {
      setIsNewCity(true)
    }
  }

  const updateEmail = (e) => {
    setEmailError(false)
    setError(null)
    setEmail(e)
  }

  const HandleGift = (e) => {
    console.log(e.target.value)
  }

  const SubmitForm = (e) => {
    e.preventDefault()

    // Validate title
    if (!title) {
      setTitleError(true)
      setError('Please choose the giftee title')
      return
    }

    // Validate first name
    if (!firstName) {
      setFirstNameError(true)
      setError('Please enter the giftee first name')
      return
    }

    // Validate last name
    if (!lastName) {
      setLastNameError(true)
      setError('Please enter the giftee last name')
      return
    }

    // Validate over 50
    if (!over50) {
      setOver50Error(true)
      setError('Please confirm the giftee is over 50')
      return
    }

    if (over50 == 'No') {
      setOver50Error(true)
      setError('Freebird Club is available to over 50s only')
      return
    }

    // Validate country
    if (!country) {
      setCountryError(true)
      setError('Please choose the giftee country of residence')
      return
    }

    // Validate city
    if (isNewCity) {
      if (!cityInput) {
        setCityError(true)
        setError('Please choose the giftee city of residence')
        return
      }
    } else {
      if (!citySelect) {
        setCityError(true)
        setError('Please choose the giftee city of residence')
        return
      }
    }

    // Validate email
    if (!isValidEmail(email)) {
      setEmailError(true)
      setError('Please enter a valid email address')
      return
    }

    if (email == history.location.state.custodian.email) {
      setEmailError(true)
      setError(
        'The giftee email address cannot be the same as your email. Please enter a unique email address for the giftee.'
      )
      return
    }

    setLoading(true)

    var recipient = {
      user_type: 'recipient',
      title: title,
      firstName: firstName,
      secondName: lastName,
      overfifty: over50,
      dob: '1968-01-01',
      country: country,
      city: cityInput,
      cities: cities,
      locationId: isNewCity ? 0 : citySelect,
      email: email,
      password: '',
      password_confirmation: '',
      is_new_city: isNewCity,
      isVerified: false,
      address_line: '',
      second_address_line: '',
      country_region: '',
      languages: [],
      discount_code:
        cookies.get('dC') != '' && cookies.get('dC') != null
          ? cookies.get('dC')
          : null,
      landing_page_code:
        cookies.get('tT') != '' && cookies.get('tT') != null
          ? cookies.get('tT')
          : null,
      source_code:
        cookies.get('sC') != '' && cookies.get('sC') != null
          ? cookies.get('sC')
          : null,
      price_code:
        cookies.get('pC') != '' && cookies.get('pC') != null
          ? cookies.get('pC')
          : null,
      currency_value:
        cookies.get('cV') != '' && cookies.get('cV') != null
          ? cookies.get('cV')
          : null,
      language_code:
        cookies.get('lC') != '' && cookies.get('lC') != null
          ? cookies.get('lC')
          : null,
      utm_source:
        cookies.get('utmS') != '' && cookies.get('utmS') != null
          ? cookies.get('utmS')
          : null,
      utm_medium:
        cookies.get('utmM') != '' && cookies.get('utmM') != null
          ? cookies.get('utmM')
          : null,
      utm_campaign:
        cookies.get('utmCa') != '' && cookies.get('utmCa') != null
          ? cookies.get('utmCa')
          : null,
      utm_content:
        cookies.get('utmCo') != '' && cookies.get('utmCo') != null
          ? cookies.get('utmCo')
          : null,
    }

    localStorage.setItem('recipient', JSON.stringify(recipient))

    delete recipient.cities

    history.location.state.custodian.country = country
    history.location.state.custodian.city = cityInput
    history.location.state.custodian.locationId = isNewCity ? 0 : citySelect

    const auth = props.auth
    const data = {
      user: recipient,
      custodian: history.location.state.custodian,
    }

    axios
      .post('/api/register-gift', data)
      .then((response) => {
        gaEvents.eventGeneric('form_submit', 'submitted', 'GYGU recipient form')
        auth.refreshUser()
        auth.handleLogin(response.data)
        gaEvents.eventSignup(response.data.id)
        history.push('/gift-your-grown-up/payment-choice')
      })
      .catch((err) => {
        setError(err)
        setLoading(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <CustomContainer>
      {loading && <Spinner />}
      <Box>
        <BackOutline padding="4px 20px">
          <Link onClick={() => props.history.go(-1)}>{pageText[0]}</Link>
        </BackOutline>
        <ContainerFlexColumn center padding="80px 0" paddingSm="30px 0">
          <CustomSubtitle
            size="22px"
            sizemd="22px"
            sizesm="17px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[1]}`,
            }}
          />
          <LineBreak />
          <Title
            center
            smCenter
            size="30px"
            sizemd="25px"
            sizesm="22px"
            margin="0 0 50px 0"
            dangerouslySetInnerHTML={{ __html: `${pageText[2]}` }}
          />
          <Form onSubmit={(e) => HandleGift(e)}>
            {/* Title */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[18]}`,
              }}
            />
            <CustomSelect
              placeholder={pageText[19]}
              defaultValue={{
                value: title ? title : '',
                label: title ? title : 'Select..',
              }}
              className={titleError && 'error-border'}
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={true}
              name="title"
              options={[
                {
                  value: pageText[15],
                  label: pageText[15],
                },
                {
                  value: pageText[16],
                  label: pageText[16],
                },
                {
                  value: pageText[17],
                  label: pageText[17],
                },
              ]}
              onChange={(e) => updateTitle(e)}
            />
            {/* Name */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[4]}`,
              }}
            />
            <Input
              id="custodian-firstName"
              type="text"
              name="firstName"
              className={firstNameError && 'error-border'}
              placeholder={pageText[4]}
              required
              value={firstName}
              onChange={(e) => updateFirstName(e.target.value)}
            />
            {/* Last Name */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[5]}`,
              }}
            />
            <Input
              id="custodian-secondName"
              type="text"
              name="secondName"
              className={lastNameError && 'error-border'}
              placeholder={pageText[5]}
              required
              value={lastName}
              onChange={(e) => updateLastName(e.target.value)}
            />
            {/* Over 50? */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            />
            <CustomSelect
              placeholder={pageText[19]}
              defaultValue={{
                value: over50 ? over50 : '',
                label: over50 ? over50 : 'Select..',
              }}
              className={over50Error && 'error-border'}
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={true}
              name="over50"
              options={[
                {
                  value: pageText[20],
                  label: pageText[20],
                },
                {
                  value: pageText[21],
                  label: pageText[21],
                },
              ]}
              onChange={(e) => updateOver50(e)}
            />
            {/* Country */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[7]}`,
              }}
            />
            <CustomSelect
              placeholder={pageText[19]}
              defaultValue={'Select..'}
              value={countrySelected}
              className={countryError && 'error-border'}
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={true}
              name="country"
              options={search.countriesNice}
              onChange={(e) => updateCountry(e)}
            />
            {/* Town */}
            {!isNewCity ? (
              <div>
                <CustomSubtitle
                  bold
                  size="18px"
                  margin="0 0 11px 0px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[8]}`,
                  }}
                />
                <CustomSelect
                  placeholder={pageText[19]}
                  defaultValue={'Select..'}
                  className={cityError && 'error-border'}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  name="town"
                  options={cities}
                  value={
                    cityInput === ''
                      ? 'Select..'
                      : {
                          label: cityInput,
                          value: citySelect,
                        }
                  }
                  onChange={(e) => updateCity(e)}
                />
              </div>
            ) : (
              <div>
                <CustomSubtitle
                  bold
                  size="18px"
                  margin="0 0 11px 0px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[23]}`,
                  }}
                />
                <Input
                  id="city"
                  type="text"
                  name="town"
                  className={cityError && 'error-border'}
                  placeholder={pageText[24]}
                  required
                  value={cityInput}
                  onChange={(e) => updateCity(e.target.value)}
                />
              </div>
            )}
            <CustomCheckboxWrapper>
              <CustomCheckboxForm onClick={(e) => updateIsNewCity(e.target)}>
                {isNewCity && <img src="/images/check-icon.svg" />}
              </CustomCheckboxForm>
              Click circle if giftee town is not listed
            </CustomCheckboxWrapper>

            {/* Email */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            />
            <Input
              id="custodian-email"
              type="email"
              name="email"
              className={emailError && 'error-border'}
              placeholder={pageText[22]}
              required
              value={email}
              onChange={(e) => updateEmail(e.target.value)}
            />

            {error && <Error error={error} />}

            <SubmitButton
              padding="12px 14px"
              type="submit"
              onClick={(e) => SubmitForm(e)}
            >
              {pageText[9]}
            </SubmitButton>
          </Form>
        </ContainerFlexColumn>
      </Box>
    </CustomContainer>
  )
}

export default withRouter(withSearch(withAuth(GiftYourRecipientForm)))
